export const SHOW_SONG_MODAL = "SHOW_SONG_MODAL";
export const HIDE_SONG_MODAL = "HIDE_SONG_MODAL";

export const SHOW_PLAYLIST_MODAL = "SHOW_PLAYLIST_MODAL";
export const HIDE_PLAYLIST_MODAL = "HIDE_PLAYLIST_MODAL";

export const SHOW_DELETE_MODAL = "SHOW_DELETE_MODAL";
export const HIDE_DELETE_MODAL = "HIDE_DELETE_MODAL";

export const SHOW_PLAYLIST_DELETE_MODAL = "SHOW_PLAYLIST_DELETE_MODAL";
export const HIDE_PLAYLIST_DELETE_MODAL = "HIDE_PLAYLIST_DELETE_MODAL";

export const SET_EDIT_MODAL = "SET_EDIT_MODAL";

export const HIDE_ALL_MODALS = "HIDE_ALL_MODALS";
